import { useState } from "react";
import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import Modal from "@shared/v2/Modal";
import TaskForm from "./TaskForm";
import { titleize } from "../../Transactions/utils/helpers";
import IconButton from "../../shared/v2/IconButton/IconButton";
import { PlusSolidV6 } from "../../shared/v2/Icomoon";
import colors from "../../Reports/components/DashboardShared/helpers/colors";

const NewTask = ({ user, taskFor, buttonStyle, nextTask, taskable }) => {
  const [showModal, setshowModal] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setshowModal(true);
  };

  const closeModal = () => {
    setshowModal(false);
  };

  const nextDueTasksState = (dueDate) => {
    const today = Brivity.LocalTimeZone ? dayjs().tz(Brivity.LocalTimeZone).format("YYYY-MM-DD") : "";
    let state = { state_color: "text-info", state: "Upcoming" };
    if (dueDate === today) {
      state = { state_color: "text-warning", state: "Due Today" };
    }
    if (dueDate < today) {
      state = { state_color: "text-danger", state: "Overdue" };
    }
    return state;
  };

  const renderModal = () => {
    if (!showModal) return null;
    return (
      <Modal
        show={showModal}
        onHide={closeModal}
        id="new-task-modal"
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[750px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
      >
        <TaskForm
          showHeader
          taskable={taskable}
          onClose={closeModal}
          taskFor={taskFor}
          showTaskFor={!taskFor}
          user={user}
        />
      </Modal>
    );
  };

  return (
    <>
      {buttonStyle === "link" ? (
        <div className="tw-pl-[40px]">
          {nextTask ? (
            <>
              <h6 className={`tw-m-0 ${nextDueTasksState(nextTask.due_on).state_color}`}>
                {titleize(nextDueTasksState(nextTask.due_on).state)}
              </h6>
              {nextTask.due_on != null && (
                <h6 className="tw-m-0">{dayjs(nextTask.due_on).format("MM-DD-YYYY")}</h6>
              )}
            </>
          ) : (
            <IconButton schema="tertiary" size="small" onClick={openModal}>
              <PlusSolidV6 />
            </IconButton>
          )}
        </div>
      ) : (
        <IconButton
          schema="transparent"
          title="New Task"
          className={`${colors.theme === "place" ? "tw-text-white" : ""} hover:tw-bg-gray/10`}
          onClick={openModal}
        >
          <PlusSolidV6 />
        </IconButton>
      )}
      {renderModal()}
    </>
  );
};

NewTask.propTypes = {
  user: PropTypes.shape(),
  taskFor: PropTypes.string,
  buttonStyle: PropTypes.string,
  nextTask: PropTypes.shape(),
  taskable: PropTypes.shape(),
};

NewTask.defaultProps = {
  user: {},
  taskFor: undefined,
  buttonStyle: undefined,
  nextTask: undefined,
  taskable: undefined,
};

export default NewTask;
